namespace TotalPoll {
    import UniqueIdService = TotalCore.Common.Providers.UniqueIdService;
    import IRootScopeService = angular.IRootScopeService;
    import Component = TotalCore.Common.Component;

    @Component('components.totalpoll', {
        templateUrl: 'fields-component-template',
        bindings: {
            items: '=',
        }
    })
    class FieldsComponent {
        public bulkContent = '';
        public bulkInput = false;
        public items: any[];
        public presets = [];

        constructor(private $rootScope: IRootScopeService, private UniqueIdService: UniqueIdService) {
            this.presets.push({
                pattern: /name/gi,
                type: 'text',
            });
            this.presets.push({
                pattern: /mail/gi,
                type: 'text',
                validations: {filled: {enabled: true}, email: {enabled: true}}
            });
            //@PRO
            this.presets.push({
                pattern: /phone|mobile|landline/gi,
                type: 'text',
                validations: {
                    regex: {enabled: true, type: 'match', expression: '^\\(?\\+?([0-9]{1,4})\\)?[-\\. ]?(\\d{10})$', errorMessage: 'Invalid phone number'}
                }
            });
            this.presets.push({
                pattern: /gender|sex/gi,
                type: 'select',
                options: 'male : Male\nfemale : Female',
            });
            this.presets.push({
                pattern: /agree|accept|tos|terms|conditions/gi,
                type: 'checkbox',
                options: 'yes : I have read and I agree with the conditions',
                validations: {filled: {enabled: true}}
            });
            this.presets.push({
                pattern: /country/gi,
                type: 'select',
                options: 'Afghanistan\nÅland Islands\nAlbania\nAlgeria\nAmerican Samoa\nAndorra\nAngola\nAnguilla\nAntarctica\nAntigua & Barbuda\nArgentina\nArmenia\nAruba\nAscension Island\nAustralia\nAustria\nAzerbaijan\nBahamas\nBahrain\nBangladesh\nBarbados\nBelarus\nBelgium\nBelize\nBenin\nBermuda\nBhutan\nBolivia\nBosnia & Herzegovina\nBotswana\nBrazil\nBritish Indian Ocean Territory\nBritish Virgin Islands\nBrunei\nBulgaria\nBurkina Faso\nBurundi\nCambodia\nCameroon\nCanada\nCanary Islands\nCape Verde\nCaribbean Netherlands\nCayman Islands\nCentral African Republic\nCeuta & Melilla\nChad\nChile\nChina\nChristmas Island\nCocos\nColombia\nComoros\nCongo - Brazzaville\nCongo - Kinshasa\nCook Islands\nCosta Rica\nCôte d’Ivoire\nCroatia\nCuba\nCuraçao\nCyprus\nCzech Republic\nDenmark\nDiego Garcia\nDjibouti\nDominica\nDominican Republic\nEcuador\nEgypt\nEl Salvador\nEquatorial Guinea\nEritrea\nEstonia\nEthiopia\nFalkland Islands\nFaroe Islands\nFiji\nFinland\nFrance\nFrench Guiana\nFrench Polynesia\nFrench Southern Territories\nGabon\nGambia\nGeorgia\nGermany\nGhana\nGibraltar\nGreece\nGreenland\nGrenada\nGuadeloupe\nGuam\nGuatemala\nGuernsey\nGuinea\nGuinea-Bissau\nGuyana\nHaiti\nHonduras\nHong Kong SAR China\nHungary\nIceland\nIndia\nIndonesia\nIran\nIraq\nIreland\nIsle of Man\nIsrael\nItaly\nJamaica\nJapan\nJersey\nJordan\nKazakhstan\nKenya\nKiribati\nKosovo\nKuwait\nKyrgyzstan\nLaos\nLatvia\nLebanon\nLesotho\nLiberia\nLibya\nLiechtenstein\nLithuania\nLuxembourg\nMacau SAR China\nMacedonia\nMadagascar\nMalawi\nMalaysia\nMaldives\nMali\nMalta\nMarshall Islands\nMartinique\nMauritania\nMauritius\nMayotte\nMexico\nMicronesia\nMoldova\nMonaco\nMongolia\nMontenegro\nMontserrat\nMorocco\nMozambique\nMyanmar\nNamibia\nNauru\nNepal\nNetherlands\nNew Caledonia\nNew Zealand\nNicaragua\nNiger\nNigeria\nNiue\nNorfolk Island\nNorth Korea\nNorthern Mariana Islands\nNorway\nOman\nPakistan\nPalau\nPalestinian Territories\nPanama\nPapua New Guinea\nParaguay\nPeru\nPhilippines\nPitcairn Islands\nPoland\nPortugal\nPuerto Rico\nQatar\nRéunion\nRomania\nRussia\nRwanda\nSamoa\nSan Marino\nSão Tomé & Príncipe\nSaudi Arabia\nSenegal\nSerbia\nSeychelles\nSierra Leone\nSingapore\nSint Maarten\nSlovakia\nSlovenia\nSolomon Islands\nSomalia\nSouth Africa\nSouth Georgia & South Sandwich Islands\nSouth Korea\nSouth Sudan\nSpain\nSri Lanka\nSt. Barthélemy\nSt. Helena\nSt. Kitts & Nevis\nSt. Lucia\nSt. Martin\nSt. Pierre & Miquelon\nSt. Vincent & Grenadines\nSudan\nSuriname\nSvalbard & Jan Mayen\nSwaziland\nSweden\nSwitzerland\nSyria\nTaiwan\nTajikistan\nTanzania\nThailand\nTimor-Leste\nTogo\nTokelau\nTonga\nTrinidad & Tobago\nTristan da Cunha\nTunisia\nTurkey\nTurkmenistan\nTurks & Caicos Islands\nTuvalu\nU.S. Outlying Islands\nU.S. Virgin Islands\nUganda\nUkraine\nUnited Arab Emirates\nUnited Kingdom\nUnited States\nUruguay\nUzbekistan\nVanuatu\nVatican City\nVenezuela\nVietnam\nWallis & Futuna\nWestern Sahara\nYemen\nZambia\nZimbabwe',
            });
            //@END-PRO
        }

        $onInit() {

        }

        collapseFields() {
            this.setCollapsedForAll(true);
        }

        deleteField(fieldIndex, confirmed = false) {
            if (confirmed || confirm(window['TotalPollI18n']['Are you sure?'])) {
                this.items.splice(fieldIndex, 1);
            }
        }

        deleteFields() {
            if (confirm(window['TotalPollI18n']['Are you sure?'])) {
                this.items = [];
            }
        }

        expandFields() {
            this.setCollapsedForAll(false);
        }

        insertBulkFields() {
            //@PRO
            let fields = this.bulkContent.split("\n");
            fields.forEach((field) => {
                this.insertFieldFromPreset(field);
            });

            this.bulkContent = '';
            this.toggleBulkInput();
            //@END-PRO
        }

        insertField(args) {
            this.collapseFields();

            args = angular.extend({}, {
                uid: this.UniqueIdService.generate(),
                type: 'text',
                label: 'Field',
                defaultValue: '',
                options: '',
                collapsed: false,
                validations: {},
                attributes: {},
                template: '',
            }, args);
            this.items.push(args);
        }

        insertFieldFromPreset(field) {
            let args: any = {
                type: 'text',
                label: field.replace(/\W/g, ' ').trim(),
                name: field.replace(/\W/g, '').toLowerCase(),
                validations: {filled: {enabled: /\*/g.test(field)}},
            };

            if (args.name !== '') {
                for (let preset of this.presets) {
                    if (args.name.match(preset.pattern)) {
                        args = angular.extend({}, args, preset);
                        delete args.pattern;
                        break;

                    }
                }

                this.insertField(args);
            }
        }

        // COLLAPSING
        setCollapsedForAll(collapsed) {
            this.items.forEach(function (item) {
                item.collapsed = collapsed;
            });
        }

        toggleBulkInput() {
            //@PRO
            this.bulkInput = !this.bulkInput;
            //@END-PRO
        }

    }
}
